import Link from 'next/link';
import React from 'react';

import { renderStoryblokRichText } from '../../../utils/renderStoryblokRichText';

type Props = {
  artist: RelatedArtist;
  title: string;
  summary: string;
  description: string;
};

const SeriesAbstract: React.FC<Props> = ({
  artist,
  description,
  summary,
  title,
}) => {
  return (
    <div className="col-span-12 md:col-span-6">
      <div className="flex flex-col transition duration-300 hover:text-neutral-4 peer-hover:text-neutral-4">
        <p className="text-md font-bold md:text-lg">
          <Link href={`/${(artist as ResolvedRelatedArtist).artist.full_slug}`}>
            {(artist as ResolvedRelatedArtist).artist.name}
          </Link>
        </p>
      </div>
      <h1 className="text-md md:text-lg">{title}</h1>
      <p className="pb-3 text-md text-neutral-4 md:pb-4 md:text-lg">
        {summary}
      </p>
      <div>{renderStoryblokRichText(description)}</div>
    </div>
  );
};

export default SeriesAbstract;
